import React from 'react';

const ServiceCategory = ({ image, title, onClick }) => {
  return (
    <div className="relative rounded-lg overflow-hidden" onClick={onClick}>
      <img src={image} alt={title} className="w-full h-32 object-cover" />
      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-2">
        <h3 className="text-white text-sm font-medium">{title}</h3>
      </div>
    </div>
  );
};

export default ServiceCategory;